import React, { useEffect, useMemo, useRef, useState } from 'react';
import {connect} from 'react-redux';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import Cookie from 'js-cookie';

import pushGA from '../../../services/utils/pushGA';
import { loadRecommendationRoutes } from '../../../services/services/AdsService';
import { isEmpty } from '../../../services/utils/utils';
import SpecialOffersItem from './SpecialOffersItem'

import {
    analyticsMainPageBlockLoaded,
    analyticsMainPageBlockShown
} from '../../../services/analytics/analyticsMainpage';

import '../new-mainpage/special-offers.scss';

const OFFERSCOUNT = 6;
const SOURCE = 'OFFER_SERVICE';

const mapStateToProps = ({App, User}) => ({App, User});

let alreadyShown = false;

const SpecialOffers = (props) => {
    const { words, getMessage } = props;
    const { App: {lang, currency} } = props;
    const {User: { profile }} = props;

    const [ offers, setOffers ] = useState({});
    const [ gotOffers, setGotOffers ] = useState(false);

    let offerRef = useRef(null);
    const airport = Cookie.get('airport') || 'DME';

    useEffect(() => {
        if(!alreadyShown && !isEmpty(offers) && offerRef && offerRef.current) {
            const observerCallback = entries => {
                const [entry] = entries;
                if (alreadyShown || !entry.isIntersecting) {
                    return;
                }

                alreadyShown = true;

                setTimeout(()=> {
                    analyticsMainPageBlockShown({
                        step: 'special_offers',
                        items: ecomParamsForGA,
                        ux: 'auto_open'
                    })
                }, 2000);
            };
            const observeOptions = {
                rootMargin: '0px',
                threshold: 0.1
            };
            const observer = new IntersectionObserver(observerCallback, observeOptions);
            observer.observe(offerRef.current);
            return () => observer.disconnect();
        }
    },[offers]);

    useEffect(() => {
        getMessage(words, 'com.s7.spec.fares.from');
        getMessage(words, 'com.s7.hermes.price.checkprice');
        getMessage(words, 'com.s7.header.special.order');
    }, []);

    useEffect(() => {
        alreadyShown = false;
        getSpecialOffers();
    }, [ lang, currency, profile ]);

    const getSpecialOffers = () => {
        const options = {
            currency,
            lang,
            userAirportCode: Cookie.get("airportNear") || airport,
            topN: OFFERSCOUNT,
            source: SOURCE
        };

        const profileId = Cookie.get('profileId');
        if(profileId){
            options.profileId = profileId;
        }

        loadRecommendationRoutes(options)
            .then(response => {
                setOffers(response);

                if(!isEmpty(response) && Array.isArray(response.items) && !isEmpty(response.items)) {
                    setGotOffers(true);
                    gaEvents({ type:'Load'});
                }
            }).catch(e => {
                if(!isEmpty(offers)){
                    setOffers((prevState) => ({
                        ...prevState,
                        priceUnknown: true,
                    }));
                    return;
                }
                setOffers({});
            });
    };

    useEffect(()=> {
        if(!gotOffers){
            return;
        }
        analyticsMainPageBlockLoaded({
            step: 'special_offers',
            items: ecomParamsForGA
        })
    }, [gotOffers]);

    const gaEvents = ({type, data}) =>{
        const currentData = data || offers;
        const offersType = currentData.personalized ? 'Personal' : 'Common';
        const listArray = currentData.items ? currentData.items.map(item => item.dest || item.destInfo?.parentIata || item.destInfo?.iata) : [];
        const toList = listArray.join(',');

        pushGA('PORTAL Offers',
            `${offersType} ${type}`,
            `FROM:${airport}`,
            {
                eventValue: 0,
                eventInteraction: 1,
                eventUX: undefined,
                flightDetail: `TO:${toList}`
            }
        );
    };

    const ecomParamsForGA = useMemo(() => {
        if(!offers || !offers.items || !Array.isArray(offers.items)){
            return [];
        }

        return offers.items.map((offer, index) => {
            const destIata = offer.dest || offer.destInfo?.parentIata || offer.destInfo?.iata;
            return {
                item_id: destIata,
                item_name: 'special_offers',
                affiliation: 'content',
                index: index + 1,
                location_id: 's7_main'
            }
        })
    }, [ offers ]);

    if(isEmpty(offers) || !Array.isArray(offers.items) || isEmpty(offers.items)){
        return <></>;
    }

    return  <div
            className={'special-offers'}
            ref={offerRef}
        >
            <div className={'special-offers-header'}>
                <h2
                    className={'special-offers-header-title'}
                    dangerouslySetInnerHTML={{__html: getMessage(words, 'com.s7.header.special.order')}}
                />
            </div>

            <div className={'special-offers__items'}>
                {offers.items.map((offer, index) => {
                    if(isEmpty(offer) || !offer.destInfo?.city || !offer.origInfo?.city){
                        return;
                    }

                    return <SpecialOffersItem
                        offer={offer}
                        priceUnknown={offers.priceUnknown}
                        personalized={offers.personalized}
                        key={`${offer.dest}-${offer.currency}`}
                        index={index}
                    />
                })}
            </div>
        </div>

};

export default injectIntl(connect(mapStateToProps)(React.memo(SpecialOffers)));